<div class="technicians-container">
  <h3 class="section-title">
    <i class="pi pi-users mr-2"></i>
    Intervenants
  </h3>

  <!-- Technicians list -->
  <div class="technicians-list">
    <h4 class="subsection-title">Technicien(ne)s</h4>

    <div *ngIf="technicians?.length" class="technician-items">
      <div *ngFor="let tech of technicians" class="technician-item">
        <p-avatar
          [label]="tech.initials"
          shape="circle"
          [style]="{ 'background-color': tech.color, color: 'white' }"
          size="normal"
          class="mr-2"
        >
        </p-avatar>
        <div class="technician-info">
          <span class="name"
            >{{ tech.firstname }} {{ tech.lastname }}
            <i
              class="tll fa-logo-{{ tech.erpSource }} text-{{ tech.erpSource }}"
            ></i
          ></span>
          <span *ngIf="tech.email" class="email">{{ tech.email }}</span>
        </div>
      </div>
    </div>

    <div *ngIf="!technicians?.length" class="empty-message">
      Aucun technicien assigné
    </div>
  </div>

  <p-divider></p-divider>

  <!-- Assistant section -->
  <div class="assistant-section">
    <h4 class="subsection-title">Assistant(e)</h4>

    <div *ngIf="assistant" class="technician-item">
      <p-avatar
        [label]="assistant.initials"
        shape="circle"
        [style]="{ 'background-color': assistant.color, color: 'white' }"
        size="normal"
        class="mr-2"
      >
      </p-avatar>
      <div class="technician-info">
        <span class="name"
          >{{ assistant.firstname }} {{ assistant.lastname }}</span
        >
        <span *ngIf="assistant.email" class="email">{{ assistant.email }}</span>
      </div>
    </div>

    <div *ngIf="!assistant" class="empty-message">
      Aucun(e) assistant(e) assigné(e)
    </div>
  </div>
</div>
